<template>
  <div id="notFound">
    <img src="/static/img/system128.png" class="center-block logo">

    <div class="text-center col-sm-12">
      <h1 v-if="flag === 'br'">Você está perdido?</h1>
      <h1 v-else-if="flag === 'de'">Bist du verloren?</h1>
      <h1 v-else-if="flag === 'us'">You are lost?</h1>
      <h1 v-else>¿Usted está perdido?</h1>
      <h4 v-if="flag === 'br'">Essa página não existe!</h4>
      <h4 v-else-if="flag === 'de'">This page does not exist!</h4>
      <h4 v-else-if="flag === 'us'">You are lost?</h4>
      <h4 v-else>¡Esta página no existe!</h4>
      <router-link to="/" class="vertical-5p lead">
        <span v-if="flag === 'br'">Ir para a principal.</span>
        <span v-else-if="flag === 'de'">Gehe zum Haupt.</span>
        <span v-else-if="flag === 'us'">Ve a la principal.</span>
        <span v-else>Ve a la principal.</span>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound',
  methods: {
    track () {
      this.$ga.page('/404')
    }
  },
  computed: {
    flag () {
      return this.$store.state.flag
    }
  }
}
</script>

<style>
#notFound {
  padding: 10em;
  color: white;
}
</style>



// WEBPACK FOOTER //
// 404.vue?35a19df6